export default "__VITE_ASSET__BYdsAavZ__"